import React from 'react';
import { Clock, ClipboardCheck, CalendarDays } from 'lucide-react';
import { StatCard } from '../../../common';
import { formatNumber } from '../../../../utils/format';
import { t } from '../../../../company/labels';

/** KPI row for the promoter profile: average route time plus the period's audits and assigned days. */
function PromoterTime({ averageMinutes, auditCount, assignedDays }) {
    const slow = averageMinutes > 180;
    return (
        <div className="grid gap-4 grid-cols-1 sm:grid-cols-3">
            <StatCard
                label="Tiempo Promedio en Recorrido"
                value={`${averageMinutes ?? 0} min`}
                valueTone={slow ? 'warning' : 'success'}
                icon={<Clock />}
                tone={slow ? 'warning' : 'success'}
                hint="En el período seleccionado"
            />
            <StatCard label="Auditorías" value={formatNumber(auditCount || 0)} icon={<ClipboardCheck />} tone="brand" hint="En el período seleccionado" />
            <StatCard label="Días asignados" value={formatNumber(assignedDays || 0)} icon={<CalendarDays />} tone="info" hint={`En el calendario del ${t('promotorLower')}`} />
        </div>
    );
}

export default PromoterTime;
